import { CustomField } from "@/Features";

interface FieldConfig {
  name: string;
  field: string;
  id: string;
  type: "date" | "string" | "text";
  mode: "date" | "multi-select" | "text";
  options: Array<{ option: string }> | null;
  selectionDisplayName: string | null;
  selectionIdField: string | null;
}

const safeParseJSON = (json: string) => {
  try {
    return JSON.parse(json);
  } catch {
    return [];
  }
};

const resolveFieldOptions = (
  options: string[] | string | null
): Array<{ option: string }> | null => {
  if (!options) return null;

  if (Array.isArray(options)) {
    return options.map((o) => ({ option: o }));
  }

  return safeParseJSON(options).map((o: string) => ({ option: o }));
};

const customFieldFilterResolver = (field: CustomField): FieldConfig => {
  const isSelectType =
    field.editor_type === "dropDown" || field.editor_type === "tagBox";
  const isDateType = field.editor_type === "dateBox";
  const fieldId = `custom_field_${field.field_id}`;
  const hasOptions = field.options !== null;

  return {
    name: field.field_name,
    field: fieldId,
    id: fieldId,
    type: isDateType ? "date" : isSelectType ? "string" : "text",
    mode: isDateType ? "date" : isSelectType ? "multi-select" : "text",
    options: resolveFieldOptions(field.options),
    selectionDisplayName: hasOptions ? "option" : null,
    selectionIdField: hasOptions ? "option" : null,
  };
};

// Helper function to handle arrays of custom fields
const resolveCustomFields = (fields: CustomField[]): FieldConfig[] => {
  return fields.map(customFieldFilterResolver);
};

export { customFieldFilterResolver, resolveCustomFields };
